module.exports = __webpack_public_path__ + "img/google-play.d1d2f649.png";